import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const CustomTimePicker = ({
  bgColor,
  fromTime,
  tillTime,
  handleTimeChange = () => {},
  fromTimeUpDisable = false,
  fromTimeDownDisable = false,
  tillTimeUpDisable = false,
  tillTimeDownDisable = false,
}) => {
  // const fromTimeUpDisable = fromTime.isSameOrAfter(tillTime.clone().subtract(15, 'minutes'));
  // const fromTimeDownDisable = fromTime.isSameOrBefore(moment().startOf('day'));
  // const tillTimeUpDisable = tillTime.isSameOrAfter(moment().endOf('day'));
  // const tillTimeDownDisable = tillTime.isSameOrBefore(fromTime.clone().add(15, 'minutes'));

  const timeFormat = "hh:mm A";
  return (
    <>
      <Stack
        display={"flex"}
        bgcolor={bgColor}
        borderRadius={"6px"}
        width={180}
        p={1}
        border={"1px solid #AAABAD"}
      >
        <Stack
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          mb={"2px"}
        >
          <Typography
            variant="subtitle1"
            component="subtitle1"
            style={{
              fontFamily: "DM Sans",
              color: "#565556",
              fontWeight: "400",
              fontSize: "10px",
              width: 30,
            }}
          >
            Start
          </Typography>

          <Stack
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            bgcolor={"white"}
            borderRadius={"3px"}
            border="0.5px solid #AAABAD"
            p={"4px"}
            px={1}
            ml={1}
            width={123}
          >
            <Typography
              variant="subtitle1"
              component="subtitle1"
              ml={1}
              mr={3}
              style={{
                fontFamily: "DM Sans",
                color: "#565556",
                fontWeight: "400",
                fontSize: "10px",
              }}
            >
              {fromTime.format(timeFormat)}
            </Typography>
            <Stack display={"flex"}>
              <Box
                onClick={() =>
                  !fromTimeUpDisable && handleTimeChange(fromTime, true, true)
                }
                sx={{
                  height: 15,
                  width: 18,
                  backgroundColor: "#E1E1E1",
                  borderRadius: "2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: "1px",
                  cursor: !fromTimeUpDisable && "pointer",
                  opacity: fromTimeUpDisable ? 0.5 : 1,
                }}
              >
                <KeyboardArrowUpIcon style={{ fontSize: "15px" }} />
              </Box>
              <Box
                onClick={() =>
                  !fromTimeDownDisable &&
                  handleTimeChange(fromTime, false, true)
                }
                sx={{
                  height: 15,
                  width: 18,
                  backgroundColor: "#E1E1E1",
                  borderRadius: "2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: "1px",
                  cursor: !fromTimeDownDisable && "pointer",
                  opacity: fromTimeDownDisable ? 0.5 : 1,
                }}
              >
                <KeyboardArrowDownIcon style={{ fontSize: "15px" }} />
              </Box>
            </Stack>
          </Stack>
        </Stack>

        <Stack
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography
            variant="subtitle1"
            component="subtitle1"
            style={{
              fontFamily: "DM Sans",
              color: "#565556",
              fontWeight: "400",
              fontSize: "10px",
              width: 30,
            }}
          >
            End
          </Typography>

          <Stack
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            bgcolor={"white"}
            borderRadius={"3px"}
            border="0.5px solid #AAABAD"
            p={"4px"}
            px={1}
            ml={1}
            width={123}
          >
            <Typography
              variant="subtitle1"
              component="subtitle1"
              ml={1}
              mr={3}
              style={{
                fontFamily: "DM Sans",
                color: "#565556",
                fontWeight: "400",
                fontSize: "10px",
              }}
            >
              {tillTime.format(timeFormat)}
            </Typography>
            <Stack display={"flex"}>
              <Box
                onClick={() =>
                  !tillTimeUpDisable && handleTimeChange(tillTime, true, false)
                }
                sx={{
                  height: 15,
                  width: 18,
                  backgroundColor: "#E1E1E1",
                  borderRadius: "2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: "1px",
                  cursor: !tillTimeUpDisable && "pointer",
                  opacity: tillTimeUpDisable ? 0.5 : 1,
                }}
              >
                <KeyboardArrowUpIcon style={{ fontSize: "15px" }} />
              </Box>
              <Box
                onClick={() =>
                  !tillTimeDownDisable &&
                  handleTimeChange(tillTime, false, false)
                }
                sx={{
                  height: 15,
                  width: 18,
                  backgroundColor: "#E1E1E1",
                  borderRadius: "2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: "1px",
                  cursor: !tillTimeDownDisable && "pointer",
                  opacity: tillTimeDownDisable ? 0.5 : 1,
                }}
              >
                <KeyboardArrowDownIcon style={{ fontSize: "15px" }} />
              </Box>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

export default CustomTimePicker;
